import Core from "@/modules/core/service/Core";

const state = {
    enums: null,
    assignments: [],
}

const mutations = {
    updateDispositionEnums (state, payload) {
        state.enums  = payload;
    },

    updateAssignments (state, assignments) {
        state.assignments  = assignments;
    },
}

const actions = {
    initDispositionEnums ( { commit }) {
        return Core.method.get("/api/disposition/enums").then(data => {
            commit ('updateDispositionEnums', data);
        });
    },

    setAssignments ( { commit }, assignments) {
        commit ('updateAssignments', assignments);
    },
}

const getters = {
    disposition: state => {
        return state.enums;
    },

    assignments: state => {
        return state.assignments;
    }
}

const dispositionModule = {
    state,
    mutations,
    actions,
    getters
}

export default dispositionModule